@let features = features$ | async;
@if(features && features.length > 0 ) {
  <mat-expansion-panel class="objects-list"
                       [expanded]="isExpanded()"
                       (opened)="isExpanded.set(true)"
                       (closed)="isExpanded.set(false)">
    <mat-expansion-panel-header>
      <mat-panel-title i18n="@@core.drawing.objects-list">Objects</mat-panel-title>
      <mat-panel-description>{{ features.length }}</mat-panel-description>
    </mat-expansion-panel-header>
    @for (feature of features; track feature.__fid; let index = $index) {
      <div class="row"
           [attr.data-feature-fid]="feature.__fid"
           [class.selected]="feature.selected">
        <button type="button"
                class="row-select"
                (click)="selectFeature(feature.__fid)"
                (dblclick)="selectFeatureAndEditDescription(feature.__fid)">
          <div class="icon">
            <tm-drawing-style-icon [type]="feature.attributes.type" [featureStyle]="feature.attributes.style"></tm-drawing-style-icon>
          </div>
          <div class="counter">#{{index + 1}}</div>
          @if(editingDescriptionForFeatureFid !== feature.__fid) {
            <div class="label">{{ stripMacros(feature.attributes.style.description) }}</div>
          }
        </button>
        @if(editingDescriptionForFeatureFid === feature.__fid) {
          <input #editDescription
                 [value]="feature.attributes.style.description ?? ''"
                 (keyup.escape)="cancelDescriptionEdit()"
                 (keyup.enter)="updateDescription()"
                 (blur)="updateDescription()"/>
        }
        <button mat-icon-button
                type="button"
                class="row-copy"
                (click)="copyFeatureWkt(feature.geometry)"
                i18n-tmTooltip="@@core.drawing.copy-object-wkt"
                tmTooltip="Copy WKT of drawing object">
          <mat-icon svgIcon="copy"></mat-icon>
        </button>
      </div>
    }
  </mat-expansion-panel>
}
